(function() {
    'use strict';

    angular
        .module('elogbooks.admin.action-types', []);
})();
